var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var FundraisingEntryNode_1, FundraisingAssignmentNode_1;
import { DateTime } from "luxon";
import { Field, Float, ObjectType, registerEnumType } from "type-graphql";
import { Node } from "../relay.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { BatchType } from "./DailyDepartmentNotification.js";
import { TimestampedResource } from "./Resource.js";
import { SolicitationCodeNode } from "./SolicitationCode.js";
export const FundraisingEntrySource = {
    DBFunds: "DBFunds",
    DDN: "DDN",
    Override: "Override",
};
registerEnumType(FundraisingEntrySource, {
    name: "FundraisingEntrySource",
});
let FundraisingEntryNode = FundraisingEntryNode_1 = class FundraisingEntryNode extends TimestampedResource {
    id;
    donatedByText;
    donatedByOverride;
    donatedToText;
    donatedToOverride;
    donatedOn;
    donatedOnOverride;
    amount;
    amountOverride;
    amountUnassigned;
    notes;
    solicitationCodeOverride;
    batchType;
    batchTypeOverride;
    source;
    text() {
        return `Donation of $${this.amount} via ${this.source} from ${this.donatedByText || "Unknown"} to ${this.donatedToText || "Unknown"} on ${this.donatedOn?.toLocaleString(DateTime.DATE_SHORT) || "Unknown"}`;
    }
    getUniqueId() {
        return this.id.id;
    }
    static init(init) {
        return FundraisingEntryNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: true, name: "donatedByText" }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "donatedByText", void 0);
__decorate([
    Field(() => String, { nullable: true, name: "donatedByOverride" }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "donatedByOverride", void 0);
__decorate([
    Field(() => String, { nullable: true, name: "donatedToText" }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "donatedToText", void 0);
__decorate([
    Field(() => String, { nullable: true, name: "donatedToOverride" }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "donatedToOverride", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true, name: "donatedOn" }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "donatedOn", void 0);
__decorate([
    Field(() => DateTimeScalar, {
        nullable: true,
        name: "donatedOnOverride",
    }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "donatedOnOverride", void 0);
__decorate([
    Field(() => Float, { nullable: false }),
    __metadata("design:type", Number)
], FundraisingEntryNode.prototype, "amount", void 0);
__decorate([
    Field(() => Float, { nullable: true }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "amountOverride", void 0);
__decorate([
    Field(() => Float, { nullable: false }),
    __metadata("design:type", Number)
], FundraisingEntryNode.prototype, "amountUnassigned", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "notes", void 0);
__decorate([
    Field(() => SolicitationCodeNode, { nullable: true }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "solicitationCodeOverride", void 0);
__decorate([
    Field(() => BatchType, { nullable: false }),
    __metadata("design:type", String)
], FundraisingEntryNode.prototype, "batchType", void 0);
__decorate([
    Field(() => BatchType, { nullable: true }),
    __metadata("design:type", Object)
], FundraisingEntryNode.prototype, "batchTypeOverride", void 0);
__decorate([
    Field(() => FundraisingEntrySource, { nullable: false }),
    __metadata("design:type", String)
], FundraisingEntryNode.prototype, "source", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], FundraisingEntryNode.prototype, "text", null);
FundraisingEntryNode = FundraisingEntryNode_1 = __decorate([
    ObjectType({
        implements: [Node],
    })
], FundraisingEntryNode);
export { FundraisingEntryNode };
let FundraisingAssignmentNode = FundraisingAssignmentNode_1 = class FundraisingAssignmentNode extends TimestampedResource {
    id;
    amount;
    getUniqueId() {
        return this.id.id;
    }
    text() {
        return `Assignment of $${this.amount}`;
    }
    static init(init) {
        return FundraisingAssignmentNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], FundraisingAssignmentNode.prototype, "id", void 0);
__decorate([
    Field(() => Float, { nullable: false }),
    __metadata("design:type", Number)
], FundraisingAssignmentNode.prototype, "amount", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], FundraisingAssignmentNode.prototype, "text", null);
FundraisingAssignmentNode = FundraisingAssignmentNode_1 = __decorate([
    ObjectType({
        implements: [Node],
    })
], FundraisingAssignmentNode);
export { FundraisingAssignmentNode };
//# sourceMappingURL=Fundraising.js.map